<template>
  <v-dialog v-model="child_dialog" max-width="80%">
    <app-card>
      <app-section-loader :status="form_loader"></app-section-loader>
      <v-card-title>
        <h3>Cập nhật phiếu thay đồng hồ {{ form.type === "E" ? "Điện" : "Nước" }}</h3>
      </v-card-title>
      <h3 class="fs-14 grey--text ml-3">Mã phiếu: {{ form.receipt_id }}</h3>
      <v-form ref="form">
        <v-container fluid>
          <v-layout row wrap justify-center>
            <v-flex xs12 md4>
              <v-select
                label="Tòa nhà"
                :disabled="loading.submit"
                v-model="form.building"
                :items="list_building"
                prepend-icon="domain"
                :rules="[rules.required]"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 md4>
              <v-autocomplete
                label="Số phòng"
                :disabled="loading.submit"
                v-model="form.room_id"
                :items="room_ids"
                item-text="room_id"
                item-value="rooms_id"
                prepend-icon="meeting_room"
                :rules="[rules.required]"
                required
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4>
              <v-menu
                :close-on-content-click="false"
                v-model="menu_change_date"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="form.change_date"
                  label="Ngày thay đồng hồ"
                  :disabled="loading.submit"
                  prepend-icon="event"
                  readonly
                  :rules="[rules.required]"
                ></v-text-field>
                <v-date-picker
                  locale="vi-VI"
                  v-model="form.change_date"
                  @input="menu_change_date = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Số đồng hồ cũ"
                :disabled="loading.submit"
                v-model="form.old_meter_number"
                prepend-icon="receipt"
                type="number"
                :rules="[
                  (value) =>
                    value === null || value >= 0 || 'Giá trị phải >= 0',
                ]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Số đồng hồ mới"
                :disabled="loading.submit || !form.old_meter_number"
                v-model="form.new_meter_number"
                prepend-icon="receipt"
                type="number"
                :rules="[
                  (value) =>
                    value === null || value >= 0 || 'Giá trị phải >= 0',
                ]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Ghi chú"
                :disabled="loading.submit"
                v-model="form.note"
                prepend-icon="event_note"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="loading.submit" @click="cancelInput">Trở về</v-btn>
          <v-btn
            :loading="loading.submit"
            :disabled="loading.submit"
            @click="submit"
            color="primary"
            >Tạo</v-btn
          >
        </v-card-actions>
      </v-form>
    </app-card>
  </v-dialog>
</template>

<script>
import api from "Api";
import { list_building } from "Constants/db-config";

export default {
  name: "dialog-edit-thay-dong-ho-dien-nuoc",
  props: {
    dialog: Boolean,
    meter_change: Object,
  },
  data() {
    return {
      child_dialog: false,
      list_building,
      form_loader: false,
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      form: {
        building: "",
        type: "",
        room_id: "",
        old_meter_number: "",
        new_meter_number: "",
        change_date: "",
        note: "",
      },
      loading: {
        submit: false,
      },
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      menu_change_date: false,
    };
  },
  watch: {
    dialog(nv) {
      if (nv && this.meter_change) {
        this.form = {
          ...this.meter_change,
          change_date: this.meter_change.change_date.split("T")[0],
        };
      }
      this.child_dialog = this.dialog;
    },
    child_dialog(nv) {
      this.$emit("changeDialogState", nv);
    },
  },
  methods: {
    cancelInput() {
      this.child_dialog = false;
      this.$refs.form.reset();
    },
    submit: async function() {
      if (!this.$refs.form.validate()) {
        swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
      }

      this.loading = true;

      const _id = this.meter_change._id;

      const postData = {
        ...this.form,
      };

      delete postData._id;

      const data = await api.updateMeterChange(_id, postData);

      this.loading = false;

      if (data.status === 200) {
        this.child_dialog = false;
        this.$emit("getData");
        swal.fire("Thành công", data.data.message, "success");
      } else swal.fire("Lỗi", data.message, "error");
    },
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    room_ids() {
      return this.rooms.filter((room) => room.building === this.form.building);
    },
  },
};
</script>
